import { Grid, Box, Button, Typography } from '@mui/material';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useState } from 'react';
import { FRONTEND_URL } from '../../appConstants';

const CheckoutForm = ({ type, transactionID, paymentIntent, p = 2, cancelPayment }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  console.log("errorMessage", errorMessage);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      console.error("Stripe.js is not initialized");
      setErrorMessage('Stripe has not loaded yet. Please try again.');
      return;
    }

    try {
      console.log("Confirming Payment...");
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${FRONTEND_URL}facility/timesheet/payment/${transactionID}`,
        },
      });

      if (error) {
        console.error("Payment failed:", error);
        setErrorMessage(error.message || 'Payment failed. Please try again.');
      } else if (paymentIntent) {
        console.log("Payment successful:", paymentIntent);
        window.location.href = `${FRONTEND_URL}facility/timesheet/payment/${transactionID}`;
      }
    } catch (err) {
      console.error("Unexpected error:", err);
      setErrorMessage("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <Box component="form" sx={{ p }}>
      <PaymentElement className="paymentMethod" />
      <Grid container spacing={2} justifyContent="center" mt={2}>
        <Grid item>
          <Button
            variant="contained"
            color="warning"
            onClick={cancelPayment}
            disabled={!stripe}
            sx={{ borderRadius: '10px', width: '110px', height: '40px' }}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="success"
            disabled={!stripe}
            sx={{ borderRadius: '10px', width: '110px', height: '40px' }}
          >
            Pay
          </Button>
        </Grid>
      </Grid>
      {errorMessage && (
        <Typography color="error" mt={2} textAlign="center">
          {errorMessage}
        </Typography>
      )}
    </Box>
  );
};

export default CheckoutForm;

